import React from 'react'
import { useProfessionalCapacity } from 'hooks/useProfessionalCapacity'
import { useProfile } from 'hooks/useProfile'
import { getCapacityState } from 'utils/getCapacityState'
import { CapacityState } from 'services/metrics/types'
import { CapacityCounter } from './CapacityCounter'
import { CapacityBanner } from './CapacityBanner'
import { CAPACITY_COPY, COUNTER_TOOLTIPS } from './copy'
import * as S from './styles'

const ACTIVE_PATIENTS_COLOR: Record<CapacityState, 'default' | 'primary' | 'danger'> = {
  empty: 'default',
  below: 'default',
  equal: 'primary',
  above: 'danger',
}

export const CapacityStrip: React.FC = () => {
  const { isPsychologist } = useProfile()
  const { data, isLoading, isError } = useProfessionalCapacity({ enabled: isPsychologist })

  if (!isPsychologist) return null

  if (isLoading || isError || !data) return null

  const state = getCapacityState(data.active_patients, data.recurring_slots)
  const copy = CAPACITY_COPY[state]

  return (
    <S.Container>
      <CapacityCounter
        value={data.active_patients}
        label="pacientes ativos"
        tooltip={COUNTER_TOOLTIPS.activePatients}
        color={ACTIVE_PATIENTS_COLOR[state]}
        hint={state === 'above' ? '↑ acima do ideal' : undefined}
      />
      <CapacityCounter
        value={data.recurring_slots}
        label="horários recorrentes"
        tooltip={COUNTER_TOOLTIPS.recurringSlots}
      />
      <CapacityBanner
        title={copy.title}
        variant={copy.variant}
        state={state}
      />
    </S.Container>
  )
}
